export const blockIconsTransportationDirectionsCarNew = (
	<span className='material-symbols-outlined'>directions_car</span>
);
